<template>
    <div v-if="isShowImg">
        <img class="top-content" src="./../../images/content.png" alt="" />
    </div>
</template>
<script>
export default {
    props: {
        userType: {
            default: null
        }
    },
    mounted() {
        if (this.userType === 1) {
            this.isShowImg = true
        } else {
            this.isShowImg = false
        }

    },
    data() {
        return {
            isShowImg: true
        }
    }
}
</script>
<style scoped lang="stylus">
@import url("./index.styl")
</style>